import React from 'react';
import { bool, string, object, arrayOf } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { NamedLink } from '..';

import css from './ProListingUserInfo.module.css';

const ProListingUserInfo = props => {
  const { className, isWarning, verificationDetails } = props;
  const intl = useIntl();

  const showMissingDocuments = verificationDetails?.missingDocuments?.length > 0;

  const discipline = verificationDetails?.discipline;
  let translatedDiscipline = discipline;

  if (discipline && intl.messages) {
    if (intl.messages[`ActivityCard.${discipline}`]) {
      translatedDiscipline = intl.formatMessage({ id: `ActivityCard.${discipline}` });
    } else if (intl.messages[`General.${discipline}`]) {
      translatedDiscipline = intl.formatMessage({ id: `General.${discipline}` });
    }
  }

  return (
    <div className={classNames(css.root, className)}>
      {isWarning && (
        <h2>
          <FormattedMessage id="ProListingUserInfo.requirementsNotFullfilled" />
        </h2>
      )}
      
      {verificationDetails?.reason === 'not_provider' ? (
        <>
          <FormattedMessage id="ProListingUserInfo.notProviderMessage" />
          <p>
            <FormattedMessage 
              id="ProListingUserInfo.switchToProvider"
              values={{
                link: (
                  <NamedLink
                    key="account-settings-profile"
                    name="ProfileSettingsPage"
                    target="_blank"
                  >
                    <FormattedMessage id="ProListingUserInfo.accountSettingsProfile" />
                  </NamedLink>
                ),
              }}
            />
          </p>
        </>
      ) : verificationDetails?.reason === 'discipline_not_verified' ? (
        <>
          <FormattedMessage 
            id="ProListingUserInfo.disciplineNotVerified"
            values={{ discipline: translatedDiscipline }}
          />
          <p>
            <FormattedMessage id="ProListingUserInfo.uploadCertificateInfo"
              values={{
                link: (
                  <NamedLink
                    key="account-settings-profile" // Corrected key to be unique or meaningful if needed
                    name="ProfileSettingsPage"
                    target="_blank"
                  >
                    <FormattedMessage id="ProListingUserInfo.accountSettingsProfile" />
                  </NamedLink>
                ),
              }}
            />
          </p>
          
          {showMissingDocuments && (
            <>
              <p>
                <FormattedMessage id="ProListingUserInfo.suggestedDocuments" />
              </p>
              <ul>
                {verificationDetails.missingDocuments.map((doc, idx) => (
                  <li key={idx}>{doc}</li>
                ))}
              </ul>
            </>
          )}
        </>
      ) : (
        <>
          <FormattedMessage id="ProListingUserInfo.lessonOrTourNote" />
          <ul>
            <li>
              <FormattedMessage
                id="ProListingUserInfo.uploadCertificateInfo"
                values={{
                  link: (
                    <NamedLink
                      key="account-settings-profile"
                      name="ProfileSettingsPage"
                      target="_blank"
                    >
                      <FormattedMessage id="ProListingUserInfo.accountSettingsProfile" />
                    </NamedLink>
                  ),
                }}
              />
            </li>
          </ul>
        </>
      )}

      {!isWarning && <FormattedMessage id="ProListingUserInfo.requirementsFullfilled" />}
    </div>
  );
};

ProListingUserInfo.propTypes = {
  className: string,
  isWarning: bool,
  verificationDetails: object,
};

export default ProListingUserInfo;
